<script>
    /**
     * Header language switcher: a nav item (globe icon + short label) with a Bootstrap dropdown.
     * Drop it inside the header's `ul.nav.navbar-nav` right after <Notification>.
     */
    import { locale, setLocale, LOCALES, localeInfo, t, suggestion, dismissSuggestion } from './index.js';

    $: current = localeInfo($locale);

    function choose(code) {
        setLocale(code);
        dismissSuggestion(); // an explicit choice ends the first-visit hint for good
    }

    // Opening the menu while the hint is shown hides the hint for this visit only.
    function onToggle() {
        if ($suggestion) dismissSuggestion(false);
    }
</script>

<style>
    /* same vertical rhythm as the theme's .dropdown-notification (bell) item */
    li.dropdown-i18n { padding: 13px 0; }
    a.nav-link { position: relative; }
    .selected-language { font-size: 0.85rem; margin-left: 0.3rem; vertical-align: middle; letter-spacing: 0.02em; }
    .i18n-hint-badge { animation: i18n-pulse 1.6s ease-in-out infinite; }
    .dropdown-item.active, .dropdown-item.active:hover { background-color: #5A8DEE; color: #FFFFFF; }
    .dropdown-item { min-width: 11rem; }
    @keyframes i18n-pulse { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.18); } }
</style>

<li class="dropdown dropdown-i18n nav-item" id="i18n-switcher">
    <a class="dropdown-toggle nav-link nav-link-label" href="#" data-toggle="dropdown" role="button"
       aria-haspopup="true" aria-expanded="false" title={$t('language.switch')} aria-label={$t('language.switch')}
       on:click={onToggle}>
        <i class="ficon bx bx-globe" class:bx-tada={!!$suggestion}></i>
        <span class="selected-language d-none d-sm-inline" lang={current.code}>{current.short}</span>
        {#if $suggestion}<span class="badge badge-pill badge-up badge-danger i18n-hint-badge">!</span>{/if}
    </a>
    <div class="dropdown-menu dropdown-menu-right">
        <h6 class="dropdown-header">{$t('language.label')}</h6>
        {#each LOCALES as l (l.code)}
            <a class="dropdown-item d-flex align-items-center justify-content-between" class:active={l.code === $locale}
               href="#" lang={l.code} on:click|preventDefault={() => choose(l.code)}>
                <span>{l.native}</span>
                {#if l.code === $locale}<i class="bx bx-check ml-1"></i>{/if}
            </a>
        {/each}
    </div>
</li>
